// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"eZ-z","subtitle":"fZ-z","wrapper":"gZ-z","leftArrow":"hZ-z","rightArrow":"iZ-z"};